module.exports = __webpack_public_path__ + "assets/img/store_package_json.23babd3d.jpg";